import { render, staticRenderFns } from "./ContactPageComponent.vue?vue&type=template&id=d58c760e&scoped=true&"
import script from "./ContactPageComponent.vue?vue&type=script&lang=js&"
export * from "./ContactPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58c760e",
  null
  
)

export default component.exports